module.exports = __webpack_public_path__ + "img/control_system.24ed0d70.jpg";